import { Cushion, MaxWidth, Rectangle, Shadow } from '@pitchero/react-ui';
import { find, flatMap, get, reject } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import Icon from '../icon';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import isServer from '../../lib/is-server';
import FilterIconWrapper from '../navigation/mobile/filter-icon-wrapper';
import SecondaryNavContainer from '../navigation/secondary-navigation-container';
import MatchFilters from './filters';

const MatchFilterBar = ({ club, eventType, teamId, onChangeEventType, onChangeTeam, t }) => {
  const [openFilter, setOpenFilter] = useState(null);

  const eventTypes = ['fixtures', 'training'];
  let eventTypeFilters = eventTypes.map((cat) => ({
    label: t(`common:calendar_event_type_${cat}`),
    value: cat,
  }));

  const selectedTeamName = teamId
    ? get(
        find(
          flatMap(club.sections, (section) => section.teams),
          { id: teamId },
        ),
        'name',
      )
    : null;
  if (selectedTeamName) {
    eventTypeFilters = reject(eventTypeFilters, { value: 'events' });
  }

  const onTabClick = (filter) => {
    if (openFilter === filter) {
      setOpenFilter(null);
    } else {
      setOpenFilter(filter);
    }
  };

  const onChangeTeamFilterHandler = (value) => {
    setOpenFilter(null);
    onChangeTeam(value);
  };

  const onChangeEventTypeFilterHandler = (value) => {
    setOpenFilter(null);
    onChangeEventType(value);
  };

  const renderFilters = () => (
    <MatchFilters
      eventType={eventType}
      eventTypeFilters={eventTypeFilters}
      club={club}
      onChangeTeam={onChangeTeamFilterHandler}
      onChangeEventType={onChangeEventTypeFilterHandler}
      openFilter={openFilter}
      sections={club.sections}
      teamId={teamId}
      t={t}
    />
  );

  const renderFilterControls = () => {
    if (isServer()) {
      return null;
    }

    return (
      <>
        <FilterIconWrapper
          filterName="team"
          filterValue={selectedTeamName}
          onFilterClick={() => onTabClick('team')}
        >
          <Icon name="t-shirt" size={20} />
        </FilterIconWrapper>
        <FilterIconWrapper
          filterName="category"
          filterValue={eventType}
          onFilterClick={() => onTabClick('category')}
        >
          <Icon name="funnel" size={20} />
        </FilterIconWrapper>
      </>
    );
  };

  const renderFilterMenu = () => (
    <Shadow>
      <Rectangle fill="white" borderTop="thinLightGrey" component="div">
        <Collapse isOpened={!!openFilter}>
          <MaxWidth component="div" maxWidth={1366} center>
            <Cushion
              horizontal="large"
              vertical={openFilter === 'month' ? 'medium' : 'xlarge'}
              component="div"
            >
              {renderFilters()}
            </Cushion>
          </MaxWidth>
        </Collapse>
      </Rectangle>
    </Shadow>
  );
  return (
    <>
      <Shadow component="div">
        <SecondaryNavContainer title="Matches">{renderFilterControls()}</SecondaryNavContainer>
      </Shadow>
      {renderFilterMenu()}
    </>
  );
};

MatchFilterBar.defaultProps = {
  eventType: null,
  teamId: null,
};

MatchFilterBar.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  eventType: PropTypes.oneOf(['events', 'fixtures', 'training']),
  onChangeEventType: PropTypes.func.isRequired,
  onChangeTeam: PropTypes.func.isRequired,
  teamId: PropTypes.number,
  t: PropTypes.func.isRequired,
};

export default MatchFilterBar;
